import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/mangifera/src/Pebbles/select';
import {
  reactSelectInlineError,
  reactSelectErrorStyles,
  SelectContainer,
  getTranslatedText
} from '@nile/components';
import { Avatar } from '@superops/ui-design-system';
import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Select from 'react-select';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';
import CreatableSelect from 'react-select/creatable';

const SelectWrapper = styled.div`
  .container > div {
    border: none !important;
  }
  .Polaris-Avatar__Image {
    width: 20px;
    height: 20px;
    background: #ad92fb !important;
  }
  .Polaris-Avatar--hasImage {
    background: #ad92fb !important;
  }
  .container {
    margin: ${(props) => (props?.noMargin ? 0 : '0px 10px')};
    width: 100%;
  }
  .user_selection .user_selector {
    width: auto !important;
  }
`;

function SelectUsers(props) {
  const [options, setoptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState(props.value);
  const {
    intl,
    updateField,
    property,
    field,
    value,
    client,
    errors,
    query,
    params,
    methodName,
    placeholder,
    isMulti,
    showAvatar,
    generateOptions,
    isDisabled,
    label,
    creatable,
    fetchBefore,
    skip,
    showEmail,
    className,
    classNamePrefix,
    isClearable
  } = props;
  const [error, setErrors] = useState('');
  const [getUsers, { called, loading, data }] = useLazyQuery(query, params);

  const resolveMethodName = (data, methodName) => {
    if (methodName === 'getClientUserAssociationsList') {
      return data?.getClientUserAssociationsList?.associations;
    } else if (
      methodName === 'getTechnicianList' ||
      methodName === 'getCompanyUsersList'
    ) {
      return data?.[methodName]?.userList;
    }
    return data?.[methodName];
  };

  useEffect(() => {
    if (generateOptions) {
      const userOptions = generateOptions(resolveMethodName(data, methodName));
      setoptions(userOptions);
    } else if (resolveMethodName(data, methodName)) {
      let users = JSON.parse(
        JSON.stringify(resolveMethodName(data, methodName))
      );

      users = users.map((el) => {
        if (methodName === 'getClientUserAssociationsList') el = el.user;

        return {
          ...el,
          label: `${el.firstName} ${el.lastName}${
            showEmail ? ` <${el.email}>` : ''
          }`,
          value: `${el.firstName} ${el.lastName}`
        };
      });
      setoptions(users);
    }
  }, [data]);

  useEffect(() => {
    setErrors(props.errors);
  }, [props.errors]);

  useEffect(() => {
    setSelectedValue(props.value);
  }, [props.value]);

  const onChangeField = (val, actionMeta) => {
    if (
      actionMeta.action === 'remove-value' ||
      actionMeta.action === 'pop-value'
    ) {
      const removedOption = actionMeta.removedValue;
      if (removedOption.isFixed) {
        return; // if it is default option in the dropdown, do not allow to remove when click backspace
      }
    }
    updateField(val);
  };

  const constructDropDownError = () => {
    if (errors) {
      return reactSelectInlineError(errors);
    }
    return null;
  };

  const fetchUsers = () => {
    if (!data?.[methodName] && !skip) {
      getUsers();
    } else if (generateOptions) {
      const userOptions = generateOptions(resolveMethodName(data, methodName));
      setoptions(userOptions);
    } else if (!skip) {
      getUsers();
    }
  };

  useEffect(() => {
    if (fetchBefore) {
      fetchUsers();
    }
  }, []);

  const getValue = () => {
    if (isMulti) {
      return selectedValue;
    }
    return options.find((item) => item.userId === selectedValue?.userId);
  };

  let components = {
    IndicatorSeparator,
    DropdownIndicator
  };

  props.customOptionComponent &&
    (components.Option = props.customOptionComponent);
  props.customMultiValueComponent &&
    (components.MultiValue = props.customMultiValueComponent);

  const Tag = creatable ? CreatableSelect : Select;

  const classNames = ['container w100', !props?.noMargin ? 'mlr10' : '']
    .filter(Boolean)
    .join(' ');
  return (
    <SelectWrapper className="fx select-wrapper" noMargin={props?.noMargin}>
      {showAvatar && <Avatar customer name="User" size="small" />}
      <div className={classNames}>
        {label}
        <Tag
          className={className || ''}
          onMenuOpen={() => {
            fetchUsers();
          }}
          key={`${JSON.stringify(selectedValue)}`}
          classNamePrefix={
            classNamePrefix
              ? `${classNamePrefix} value_selector`
              : 'value_selector'
          }
          formatGroupLabel={formatGroupLabel}
          value={getValue()}
          components={components}
          title={'Choose users'}
          onChange={onChangeField}
          options={skip ? [] : options}
          placeholder={
            placeholder ||
            getTranslatedText(intl, 'ticket.details.chat.pl.choose')
          }
          menuPortalTarget={document.body}
          menuPlacement="auto"
          closeMenuOnScroll={(e) => {
            return (
              e.target &&
              e.target.classList &&
              !(e.target.classList.value.indexOf('menu-list') > -1)
            );
          }}
          name="valueselector"
          styles={
            props?.errors
              ? {
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                  ...reactSelectErrorStyles,
                  ...(props.styles || {})
                }
              : {
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                  ...(props.styles || {})
                }
          }
          noOptionsMessage={() => {
            return loading ? 'Loading...' : 'No options';
          }}
          isMulti={isMulti}
          isDisabled={isDisabled}
          isClearable={isClearable}
        />
        {constructDropDownError()}
      </div>
    </SelectWrapper>
  );
}

const exportSelectUsers = injectIntl(SelectUsers);

export { exportSelectUsers as SelectUsers };
